import React from "react";

function formatTargetPrice(idea) {
    const targetPrice = idea.recommendation.targetPrice;
    return targetPrice ? Number(targetPrice.value) + " " + targetPrice.currency : "\u2014";
}

export const TargetPrice = ({idea}) => {
    return <div className="t-target-price">{formatTargetPrice(idea)}</div>;
};